import { all } from 'redux-saga/effects';
import { watcherLoginSaga } from './post_login';
import { watcherRegistrationSaga } from './post_registration';
import { watcherShortRegistrationSaga } from './post_shortRegistration';
import { watcherSavedVersionsSaga } from './get_versions';
import { watcherUserReportSaga } from './get_userReport';
import { watcherModulesListSaga } from './get_modulesList';
import { watcherAuthUserSaga } from './post_auth';
import { watcherLogoutSaga } from './post_logout';
import { watcherMessagesListSaga } from './get_messagesList';
import { watcherMessageContentSaga } from './get_messageContent';
import { watcherMessageDeleteSaga } from './delete_messageDelete';
import { watcherAddProgramSaga } from './post_addProjectCode';
import { watcherAddUserSaga } from './post_addUser';
import { watcherDeleteUserSaga } from './delete_deleteUser';
import { watcherAddTeamLeaderSaga } from './post_addTeamLeader';
import { watcherConnectedUsersSaga } from './get_connectedUsers';
import { watcherMessageSendSaga } from './post_messageSend';
import { watcherPrintReportSaga } from './post_printReport';
import { watcherGetTeamMembersSaga } from './get_teamMembers';
import { watcherForgottenPasswordSaga } from './post_forgottenPassword';
import { watcherSaveVersionSaga } from './post_version';
import { watcherUpdateMessageStatusSaga } from './put_updateMessageStatus';
import { watcherGetTeamMembersFullSaga } from './get_getTeamMembersFull';
import { watcherGetUserProgramsFullSaga } from './get_getUserProgramsFull';
import { watcherGetUserReportSaga } from './get_getUserReport';
import { watcherXapiSaga } from './post_xapi';
import { watcherAddComponentStatusSaga } from './post_addComponentStatus';
import { watcherVersionSaga } from './put_version';
import { watcherTutorialSaga } from './get_tutorial';
import { watcherDontShowTutorialSaga } from './post_dontShowTutorial';
import { watcherDropdownsSaga } from './get_dropdowns';
import { watcherCheckCodeSaga } from './checkCode';
import { watcherDeactivateSaga } from './deactivate';
import { watcherAssignmentRequestSaga } from './assignmentRequest';
import { watcherAnnouncementsSaga } from './announcements';

import { watcherSaveAnnotationSaga } from './post_saveannotations';
import { watcherSystemSaga } from './get_system';
import { watcherUpdateProfileSaga } from './post_updateProfile';
import { watchercoachRatingSaga } from './post_coachrating';
import { watcherVersionStatusSaga } from './post_versionStatus'
import { watcherMessagesSentListSaga } from './get_messagesSentList';
import { watcherUserRolloutSaga } from './get_rollout_users';
import { watcherLoginAdminSaga } from './post_loginAdmin'
import { watcherAuthAdminSaga } from './post_authAdmin';

export default function* rootSaga() {
  yield all([
    watcherLoginSaga(),
    watcherRegistrationSaga(),
    watcherShortRegistrationSaga(),
    watcherSavedVersionsSaga(),
    watcherUserReportSaga(),
    watcherModulesListSaga(),
    watcherAuthUserSaga(),
    watcherLogoutSaga(),
    watcherMessagesListSaga(),
    watcherMessageContentSaga(),
    watcherMessageDeleteSaga(),
    watcherAddProgramSaga(),
    watcherAddUserSaga(),
    watcherDeleteUserSaga(),
    watcherAddTeamLeaderSaga(),
    watcherConnectedUsersSaga(),
    watcherMessageSendSaga(),
    watcherPrintReportSaga(),
    watcherGetTeamMembersSaga(),
    watcherForgottenPasswordSaga(),
    watcherSaveVersionSaga(),
    watcherUpdateMessageStatusSaga(),
    watcherGetTeamMembersFullSaga(),
    watcherGetUserProgramsFullSaga(),
    watcherGetUserReportSaga(),
    watcherXapiSaga(),
    watcherAddComponentStatusSaga(),
    watcherVersionSaga(),
    watcherTutorialSaga(),
    watcherDontShowTutorialSaga(),
    watcherDropdownsSaga(),
    watcherAssignmentRequestSaga(),
    watcherCheckCodeSaga(),
    watcherDeactivateSaga(),
    watcherAnnouncementsSaga(),
    watcherSystemSaga(),
    watcherSaveAnnotationSaga(),
    watcherUpdateProfileSaga(),
    watchercoachRatingSaga(),
    watcherVersionStatusSaga(),
    watcherMessagesSentListSaga(),
    watcherUserRolloutSaga(),
    watcherLoginAdminSaga(),
    watcherAuthAdminSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js